skrilla.controller('mergePlayerModalCtrl', function ($scope, searchService, currencyService, promotionService, modalService, cacheService, paginationService, queryService) {
    $scope.sport = cacheService.getObjectOrElse("contestSport", function(){modalService.dismissAll()})
    $scope.player = cacheService.getObjectOrElse("player", function(){modalService.dismissAll()})
    $scope.key = "mergePlayer";

    $scope.reset = function(){
        $scope.query = {
            sortBy: "name"
        }
    }
    $scope.reset();

    $scope.search = function () {
        paginationService.resetPage($scope.key);
        paginationService.pageQuery(getPlayers, $scope.key);
    }

    var getPlayers = function() {
        return searchService.get("players/" + $scope.sport + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
            $scope.players = response.data.result;
            paginationService.setPage($scope.key, paginationService.buildPage(response));
        });
    }

    $scope.merge = function(player){
        modalService.confirm("Are you sure you'd like to merge " + $scope.player.name + " to " + player.name + "?", function(){
            searchService.post("players/" + $scope.sport + "/merge", {
                entityToKeep: player.id,
                entityToRemove: $scope.player.id
              },
              $scope.player.name + " successfully merged to " + player.name).then(function(response){
                $scope.players = $scope.players.filter(function(_player){return _player.id !== player.id});
                modalService.dismissAll()
            });
        });
    }

});